import { EmailObj } from "@/store/CommonStore";
import { AxiosStatic } from "axios";

class SenderEmailService {
  axios;
  baseUrl;

  constructor(axios: AxiosStatic, apiUrl: string) {
    this.axios = axios;
    this.baseUrl = `${apiUrl}`;
  }

  sendEmail(email:EmailObj) {
    const data = {
      Body: email.Body,
      Subject: email.Subject,
      Para: email.Para.map(user => user.mail || user.userPrincipalName).join(';')
    };
    return this.axios.post(`${this.baseUrl}`, data);
  }
}

export default SenderEmailService;
